import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const getRequest = (data: any) => {
  return {
    bankName: data?.bankName,
    entityCode: data?.entityCode,
    entityId: data?.entityID,
    id: data?.id,
    rpslCode: data?.rpslCode,
    status: data?.status,
  }
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const updateNetbanking = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.updateNBMapping),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequest(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updateNetbanking }
